import { render, staticRenderFns } from "./QuickComment.vue?vue&type=template&id=40ac18fe"
import script from "./QuickComment.vue?vue&type=script&lang=js"
export * from "./QuickComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports